document.addEventListener('DOMContentLoaded', () => {
  if (typeof EmblaCarousel === 'undefined') return;

  document.querySelectorAll('[data-message-carousel-viewport]').forEach((viewport) => {
    const fieldset = viewport.closest('.message-carousel-fieldset');
    if (!fieldset) return;

    const slides = Array.from(viewport.querySelectorAll('.message-carousel-slide'));
    const startIndex = Math.max(
      0,
      slides.findIndex((slide) => slide.querySelector('input[type="radio"]')?.checked)
    );

    const emblaApi = EmblaCarousel(viewport, {
      loop: true,
      align: 'center',
      containScroll: false,
      startIndex,
      breakpoints: {
        '(min-width: 781px)': { active: false },
      },
    });

    const prevButton = fieldset.querySelector('[data-message-carousel-prev]');
    const nextButton = fieldset.querySelector('[data-message-carousel-next]');

    prevButton?.addEventListener('click', () => emblaApi.scrollPrev());
    nextButton?.addEventListener('click', () => emblaApi.scrollNext());

    const counter = fieldset.querySelector('[data-message-carousel-counter]');
    const updateCounter = () => {
      if (!counter) return;
      counter.textContent = `(${emblaApi.selectedScrollSnap() + 1}/${emblaApi.scrollSnapList().length})`;
    };
    updateCounter();
    emblaApi.on('select', updateCounter);
    emblaApi.on('reInit', updateCounter);

    viewport.addEventListener('focusin', () => {
      viewport.scrollLeft = 0;
    });

    emblaApi.slideNodes().forEach((slide, index) => {
      const input = slide.querySelector('input[type="radio"]');
      input?.addEventListener('change', () => emblaApi.scrollTo(index));
    });

    emblaApi.on('select', () => {
      const centeredSlide = emblaApi.slideNodes()[emblaApi.selectedScrollSnap()];
      const input = centeredSlide?.querySelector('input[type="radio"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});
